import { useActivityEnhancement } from '../../common/custom-hooks/useActivityEnhancement';
import { TypeMessageEnhancement } from '../../common/custom-hooks/useProjectEnhancement';
import { AiActivityEnhancementSystem } from '../../system/ai/AiActivityEnhancementSystem';
import { AiGradientIconFilled, AiGradientIconOutline } from '../AiGradientIcon';
import SmartActionButton from '../Common/SmartActionButton';
import { t } from 'i18next';
import { IAddRows } from './InterfaceTabla';

interface IAEnhanceButtonProps {
  item: IAddRows;
  aiActivityEnhancementSystem: AiActivityEnhancementSystem;
  updateActivityNameAndDescription: (id: string, newNombreAct: string, newDescripcion: string) => void;
  onWasGenerated: (wasGenerated: boolean) => void;
}

const IAEnhanceButton = ({ item, aiActivityEnhancementSystem, updateActivityNameAndDescription, onWasGenerated }: IAEnhanceButtonProps) => {
  const activityEnhancement = useActivityEnhancement(aiActivityEnhancementSystem);

  const generateAI = () => {
    const activity_name = item.nombreAct;
    const project_name = item.nombrePro.text;
    const activity_description = item.descripcion;
    const company_country = item.paisEmpresa.text;
    const company_name = item.nombreEmp.text;
    const project_code = item.nombrePro.code || '';

    if (!activity_name.trim() || !project_name.trim()) return activityEnhancement.showMessage({ type: TypeMessageEnhancement.WARNING, className: 'warning-message-animate', value: '⚠️ El nombre de la actividad y nombre del proyecto es requerido' });
    activityEnhancement.generateEnhancement({ activity_name, project_name, activity_description, company_country, company_name, project_code }, (result) => {
      updateActivityNameAndDescription(item.id, result.activity_name, result.activity_description);
      onWasGenerated(true);
    });
  };

  const resetAI = () => {
    const original = activityEnhancement.resetToOriginal();
    updateActivityNameAndDescription(item.id, original.activity_name, original.activity_description);
    onWasGenerated(false);
  };

  const disabledEnhancementButton = !activityEnhancement.wasGenerated && (activityEnhancement.loading || !item.nombreAct?.trim() || !item.nombrePro?.text?.trim());

  return (
    <SmartActionButton
      disabled={disabledEnhancementButton}
      loading={activityEnhancement.loading}
      onClick={activityEnhancement.wasGenerated ? resetAI : generateAI}
      text={activityEnhancement.loading ? t('Mejorando...') : activityEnhancement.wasGenerated ? t('Deshacer') : t('Mejorar')}
      icon={activityEnhancement.wasGenerated ? <AiGradientIconOutline /> : <AiGradientIconFilled />}
    />
  );
};

export default IAEnhanceButton;
